export function generateMessage(mes, param) {
  let result;
  for (let i = 0; i < param.length; i++) {
    let index = '{' + i + '}';
    result = mes.replace(index, param[i]);
  }
  return result;
}
